<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M24 10.67a1 1 0 00-1 1V16a7 7 0 01-14 0v-4.33a1 1 0 00-2 0V16a9 9 0 008 8.94V27h-2a1 1 0 000 2h6a1 1 0 000-2h-2v-2-.06A9 9 0 0025 16v-4.33a1 1 0 00-1-1z"/><path d="M16 21.25A5.26 5.26 0 0021.25 16V8.25a5.25 5.25 0 00-10.5 0V16A5.26 5.26 0 0016 21.25zm-3.25-13a3.25 3.25 0 016.5 0V16a3.25 3.25 0 01-6.5 0z"/></svg>